import {
  Component,
  Input,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import {
  FormGroup,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { TranslationService } from '../../../../services/translation.service'
import { MatError } from '@angular/material/form-field'
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio'
import {
  CountryRecycablilityInfo,
  RecyclabilityCountry,
} from '../../../../types/recyclability'
import { MatSelectModule } from '@angular/material/select'
import { NgOptimizedImage } from '@angular/common'
import { COUNTRY_RECYCLABILITY_OPTIONS } from '../../../../constants/country-recyclability'

@Component({
  selector: 'app-country-recyclability-info',
  imports: [
    MatRadioButton,
    MatRadioGroup,
    FormsModule,
    ReactiveFormsModule,
    MatError,
    MatSelectModule,
    NgOptimizedImage,
  ],
  templateUrl: './country-recyclability-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './country-recyclability-info.component.scss',
})
export class CountryRecyclabilityInfoComponent implements OnInit {
  translationService = inject(TranslationService)
  private fb = inject(FormBuilder)

  @Input() country?: RecyclabilityCountry
  @Input() formGroup?: FormGroup
  @Input() submitted: boolean = false

  countryRecyclability = this.fb.group({})
  countryRecyclabilityInfo: CountryRecycablilityInfo | undefined

  ngOnInit(): void {
    this.countryRecyclabilityInfo = COUNTRY_RECYCLABILITY_OPTIONS.find(
      (option) => option.country === this.country,
    )
  }
}
